import React from "react";

const CompleteTillDate = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_2220_5635)">
      <rect x="4" y="4" width="24" height="24" rx="4" fill="#E4FFEC" />
    </g>
    <path
      d="M19.2735 12.5367C19.0303 12.3448 18.6719 12.3959 18.4799 12.6391C18.288 12.8824 18.3391 13.2407 18.5823 13.4327C19.6191 14.2391 20.208 15.4424 20.208 16.7479C20.2079 19.0647 18.3135 20.9463 15.9968 20.9463C13.68 20.9463 11.7856 19.0647 11.7856 16.7479C11.7856 14.5463 13.5007 12.7287 15.664 12.5623L15.1391 13.0871C14.9216 13.3047 14.9216 13.6631 15.1391 13.8807C15.2543 13.9959 15.3951 14.0471 15.5359 14.0471C15.6767 14.0471 15.8175 13.996 15.9327 13.8807L17.4303 12.3831C17.5327 12.2807 17.5967 12.1399 17.5967 11.9863C17.5967 11.8328 17.5327 11.692 17.4303 11.5896L15.9327 10.0792C15.7151 9.86162 15.3567 9.86162 15.1391 10.0792C14.9215 10.2968 14.9215 10.6552 15.1391 10.8728L15.6895 11.4231C12.8991 11.5896 10.6719 13.9063 10.6719 16.7479C10.6719 19.6919 13.0655 22.0727 15.9967 22.0727C18.9279 22.0727 21.3215 19.6791 21.3215 16.7479C21.3215 15.0839 20.5791 13.5607 19.2734 12.5367L19.2735 12.5367Z"
      fill="#59C376"
    />
    <path
      d="M15.4064 17.185L14.5232 16.3017C14.3056 16.0841 13.9472 16.0841 13.7296 16.3017C13.512 16.5193 13.512 16.8777 13.7296 17.0953L15.0096 18.3753C15.112 18.4777 15.2528 18.5417 15.4064 18.5417C15.5599 18.5417 15.7008 18.4777 15.8032 18.3753L18.2608 15.9177C18.4783 15.7001 18.4783 15.3417 18.2608 15.1241C18.0432 14.9065 17.6848 14.9065 17.4672 15.1241L15.4064 17.185Z"
      fill="#59C376"
    />
    <defs>
      <filter
        id="filter0_d_2220_5635"
        x="0"
        y="0"
        width="32"
        height="32"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2220_5635"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2220_5635"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export default CompleteTillDate;
